import Button from '@components/Button';
import Row from '@components/Row';
import styled from '@emotion/styled';
import Add from '@icons/Add';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

function ExternalCouponFragment() {
    const { t } = useTranslation('coupon');
    return (
        <Container>
            <Link activityName='RegisterGiftActivity'
                activityParams={{}}>
                <Button fullWidth>
                    <Row spacing={1}>
                        <Add size={22}
                            color='white'/>
                        {t('external.register')}
                    </Row>
                </Button>
            </Link>
        </Container>
    );
}

const Container = styled.div`
    padding: 36px 20px;
`;

export default ExternalCouponFragment;
